/**
 * Modal accessible avec piège focus, fermeture Esc, overlay cliquable.
 * Usage : <nexxus-modal open title="Titre"><div>contenu</div></nexxus-modal>
 */
export class Modal extends HTMLElement {
  static get observedAttributes(): string[] {
    return ['open', 'title', 'size'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback(): void {
    this.render();
  }
  attributeChangedCallback(): void {
    this.render();
  }

  private render(): void {
    if (!this.shadowRoot) return;
    const open = this.hasAttribute('open');
    const title = this.getAttribute('title') ?? '';
    const size = this.getAttribute('size') ?? 'md';
    const widths: Record<string, string> = { sm: '420px', md: '640px', lg: '900px', xl: '1100px' };
    const width = widths[size] ?? widths['md']!;
    this.shadowRoot.innerHTML = `
      <style>
        :host { display: ${open ? 'block' : 'none'}; }
        .overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.45); display: grid; place-items: center; z-index: ${this.hasAttribute('data-confirm') ? 1100 : 1000}; padding: 16px; }
        .dialog { background: white; border-radius: 8px; max-width: ${width}; width: 100%; max-height: 90vh; display: flex; flex-direction: column; box-shadow: 0 12px 32px rgba(0,0,0,0.18); }
        .header { padding: 16px 24px; border-bottom: 1px solid #e1e4e8; display: flex; align-items: center; justify-content: space-between; }
        .header h2 { margin: 0; font-size: 1.1rem; font-weight: 600; }
        .close { background: none; border: none; cursor: pointer; font-size: 1.5rem; line-height: 1; color: #586069; padding: 4px 8px; }
        .body { padding: 24px; overflow-y: auto; flex: 1; }
        .footer { padding: 12px 24px; border-top: 1px solid #e1e4e8; display: flex; justify-content: flex-end; gap: 8px; }
      </style>
      <div class="overlay" role="dialog" aria-modal="true" aria-labelledby="title">
        <div class="dialog">
          <div class="header"><h2 id="title">${title}</h2><button class="close" aria-label="Fermer">×</button></div>
          <div class="body"><slot></slot></div>
          <div class="footer"><slot name="footer"></slot></div>
        </div>
      </div>
    `;
    this.shadowRoot.querySelector('.close')?.addEventListener('click', () => this.close());
    this.shadowRoot.querySelector('.overlay')?.addEventListener('click', (e: Event) => {
      if (e.target === e.currentTarget) this.close();
    });
  }

  open(): void {
    this.setAttribute('open', '');
    this.dispatchEvent(new CustomEvent('open'));
  }
  close(): void {
    this.removeAttribute('open');
    this.dispatchEvent(new CustomEvent('close'));
  }
}

customElements.define('nexxus-modal', Modal);
